module.exports = __webpack_public_path__ + "static/partner8-6824e291d3ff37d7ccd75b8754d6a20b.png";